var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-nav-list"},[_c('el-row',{attrs:{"gutter":24}},_vm._l((_vm.list),function(item,index){return _c('el-col',{key:item._id,staticClass:"nav-item-col",style:({'animation-delay': index * 0.05 + 's'}),attrs:{"lg":4,"md":6,"sm":8,"xs":12}},[_c('app-nav-item',{attrs:{"item":item}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }